



































































import { Component, Mixins } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import { PortalAccount } from "@/types/mypage";
import AxiosMixin from "@/mixins/axiosMixin";
import Title from "@/components/common/Title.vue";
import Cookies from "js-cookie";

@Component({ components: { Title } })
export default class extends Mixins(AxiosMixin) {
  /** ポータル職員一覧 */
  private kaedoki_recruiters: PortalAccount[] = [];

  /** ポータル紹介者一覧 */
  private kaedoki_recruitees: PortalAccount[] = [];

  private kaedoki_recruiter_headers: DataTableHeader[] = [
    {
      text: "",
      value: "use",
      align: "start",
      width: "240px",
      cellClass: "text-start"
    },
    {
      text: "職員名",
      value: "name",
      align: "start",
      width: "30%",
      cellClass: "text-start"
    },
    {
      text: "事業所名",
      value: "organization_name",
      align: "start",
      width: "30%",
      cellClass: "text-start"
    },
    {
      text: "権限",
      value: "role_name",
      align: "start",
      width: "40px",
      cellClass: "text-start"
    }
  ];

  private kaedoki_recruitee_headers: DataTableHeader[] = [
    {
      text: "",
      value: "use",
      align: "start",
      width: "240px",
      cellClass: "text-start"
    }
  ];

  mounted(): void {
    this.fetch();
  }

  /** データ更新 */
  private fetch() {
    this.postJsonCheck(window.base_url + "/api/kaedoki/list", {}, res => {
      this.kaedoki_recruiters = res.data.kaedoki_recruiters;
      this.kaedoki_recruitees = res.data.kaedoki_recruitees;
    });
  }

  /** カエドキを使用する */
  private useKaedoki(req: Record<string, unknown>, use_type: number) {
    this.postJsonCheck(
      window.base_url + "/outer/auth/jobsearch/token",
      req,
      res => {
        window.token = res.data.token;
        Cookies.set("token", res.data.token, {
          domain: window.cookie_domain
        });
        window.reftoken = res.data.ref_token;
        Cookies.set("reftoken", res.data.ref_token, {
          domain: window.cookie_domain
        });
        //カエドキを開く
        location.href =
          window.kaedoki_frontend_url +
          "/recept?from_ibow=1&use_type=" +
          use_type;
      }
    );
  }
}
